import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthFooterComponent } from '@app/pages/core/pages/auth/_components/auth-footer/auth-footer.component';

@Component({
  template: `
    <div class="app-auth">
      <div class="app-auth__con">
        <router-outlet />
      </div>
      <app-auth-footer />
    </div>
  `,

  styleUrls: ['./auth.component.scss'],
  imports: [RouterModule, AuthFooterComponent],
})
export class AuthComponent {}
